module.exports = __webpack_public_path__ + "img/service3.b260987b.png";